import { render } from "./VirtualBalanceBubble.vue?vue&type=template&id=1329b875"
import script from "./VirtualBalanceBubble.vue?vue&type=script&lang=js"
export * from "./VirtualBalanceBubble.vue?vue&type=script&lang=js"

import "./VirtualBalanceBubble.vue?vue&type=style&index=0&id=1329b875&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__